import React from 'react';
import { Link } from 'react-router';

const Header = () => {

    const styles = {
        headerImage: {
            width: '100%',
            height: 'auto'
        }
    };

    return (
        <div>
            <div>
                <img style={styles.headerImage} src="/images/claware_header.jpg" alt="tribal people"></img>
            </div>
            <div className="header-nav-flex-container">
                <div><Link to={'/'}>Home</Link></div>
                <div><Link to={'/download'}>Downloads</Link></div>
                <div><Link to={'/contact'}>Support / Contact Us</Link></div>
            </div>
        </div>
    );
};
Header.PropTypes = {};

export default Header;



// WEBPACK FOOTER //
// ./src/components/shared/header.js